import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import RadioGroup from '../../form/radio-group';

class Component extends BaseComponent {
    shouldComponentUpdate(nextProps) {
        if (nextProps.checkout.type != this.props.checkout.type) {
            return true;
        }

        return false;
    }

    renderCashTotal = (product) => {
        if (product.price.usd.current != product.price.usd.original) {
            return (
                <h4>
                    <span className='has-text-sushi has-text-size-32 has-weight-500'>
                        ${product.price.usd.current}
                    </span>
                    <span className='has-padding-10-left has-text-strikethrough'>
                        ${product.price.usd.original}
                    </span>
                </h4>
            );
        }

        return (<h4>${product.price.usd.current}</h4>);
    }

    render({ checkout, mode, product }) {
        if (checkout && checkout.order && !checkout.order.finalized) {
            if (mode == 'standard') {
                return (
                    <options-cash mode={mode}>
                        <row className='is-justified-center'>
                            <column className='is-7 is-12-mobile'>
                                <row className='is-justified-center is-aligned-center'>
                                    <column className='is-1 is-2-mobile'>
                                        <RadioGroup
                                            name='checkout_option'
                                            checked={checkout.type == 'cash'}
                                            onChange={this.setPurchase}
                                        />
                                    </column>
                                    <column className='is-11 is-10-mobile'>
                                        {this.renderCashTotal(product)}
                                    </column>
                                </row>
                            </column>
                        </row>
                    </options-cash>
                );
            }

            //TODO: Add subscription/kc modes
        }

        return (<options-cash mode={mode} />);
    }

    setPurchase = () => {
        this.props.trackEvent([
            'Checkout',
            'LI Click',
            'Radio Cash',
        ]);

        this.props.checkoutUpdate({
            type: 'cash',
            total: {
                current: this.props.product.price.usd.current,
                original: this.props.product.price.usd.original,
            },
        });
    }
}

const mapStateToProps = (state) => ({
    checkout: state.checkout,
    product: state.product,
});

const mapDispatchToProps = (dispatch) => ({
    checkoutUpdate: (payload) => dispatch({
        type: 'checkout:update',
        payload: payload,
    }),
    trackEvent: (payload) => dispatch({
        type: 'ga:event',
        payload: payload,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);